export default "__VITE_ASSET__660cb7e9__"